
import { AdvertCard, AdvertList } from './Ads/Advert'
import { BuyingGuideCard, BuyingGuideList } from './Ads/BuyingGuide'
import { PaymentCard, PaymentList } from './Ads/Payment'

export const ADS = {
  ADVERT: 'advert',
  BUYING_GUIDE: 'buyingGuide',
  PAYMENT: 'payment',
}
export const AD_DISPLAYS = {
  LIST: 'list',
  CARD: 'card',
}

export default {
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => Object.values(ADS).includes(value),
    },
    display: {
      type: String,
      default: AD_DISPLAYS.CARD,
      validator: (value) => Object.values(AD_DISPLAYS).includes(value),
    },
    position: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    advertComponent() {
      return {
        [AD_DISPLAYS.LIST]: AdvertList,
        [AD_DISPLAYS.CARD]: AdvertCard,
      }[this.display]
    },
    paymentComponent() {
      return {
        [AD_DISPLAYS.LIST]: PaymentList,
        [AD_DISPLAYS.CARD]: PaymentCard,
      }[this.display]
    },
    buyingGuideComponent() {
      return {
        [AD_DISPLAYS.LIST]: BuyingGuideList,
        [AD_DISPLAYS.CARD]: BuyingGuideCard,
      }[this.display]
    },
    adComponent() {
      return {
        [ADS.ADVERT]: this.advertComponent,
        [ADS.PAYMENT]: this.paymentComponent,
        [ADS.FAQ]: this.faqComponent,
        [ADS.BUYING_GUIDE]: this.buyingGuideComponent,
      }[this.name]
    },
  },
}
